import { ViewControlInterface } from 'edocatbase/Form';

const getValue = (value?: number) => {
	if (!value) {
		return '0 KB';
	}

	if (value < 1024) {
		return `${value} KB`;
	}

	if (value < Math.pow(1024, 2)) {
		return `${Math.round(value / 1024)} KB`;
	}

	if (value < Math.pow(1024, 3)) {
		return `${Math.round(value / Math.pow(1024, 2))} MB`;
	}

	if (value < Math.pow(1024, 4)) {
		return `${Math.round(value / Math.pow(1024, 3))} GB`;
	}

	return '0 KB';
};

export default class Size extends window.React.PureComponent<ViewControlInterface> {
	render() {
		const { label, value, name } = this.props;

		return (
			<div className={`form-row row-${name} simple-row`}>
				<label>{label}</label>
				<div id={name}>{getValue(value)}</div>
			</div>
		);
	}
}
